import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchAllProjects,
} from "../../../../../store/slices/projectsSlice";
import { useSnackbar } from "notistack";
import { fetchLeads } from "../../../../../store/slices/leadsSlice";
import { fetchEmployees } from "../../../../../store/slices/employeeSlice";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { createProjectRequest } from "../../../../../store/slices/managerProjectRequestedSlice";
import { setCurrentPageTitle } from "../../../../../store/slices/pageSlice";
import AdminLoader from "../../../../../components/common/loader/AdminLoader";
import { MdSearch } from "react-icons/md";
import { fetchEmployeeGroups } from "../../../../../store/slices/employeeGroup";
import FileUploadsProjectRequest from "../FileUploadsProjectRequest";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import CheckIcon from "@mui/icons-material/Check";
import { updatePrimaryResources } from "../../../../../store/slices/updatePrimaryResourcesSlice";
import { cancelManagerFromProjects } from "../../../../../store/slices/cancelManagerSlice";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { updateProjectSLAByName } from "../../../../../store/slices/projectSla.slice";
import { removePrimaryResources } from "../../../../../store/slices/removePrimaryResourcesSlice";
import { remindManager } from "../../../../../store/slices/remindManagerSlice";
import { markLeadAsReadById } from "../../../../../store/slices/leadsReadSlice";
import EmployeeDropdown from "./EmployeeDropdown";
import { setLeadReadTrue } from "../../../../../store/slices/readSlice";
import DateConversion from "../../../../../utils/DateConversion";
import { Star } from 'lucide-react';
import { createProjectKey } from "../../../../../utils/projectMatchingUtils";
import { fetchGroups } from "../../../../../store/slices/groupSlice";

const SalesPresalesOperations = ({
  handlerefresh,
  groupedProjects,
  requestedprojects,
  Setrequestedprojects,
  isViewOnly = false,
}) => {
  const dispatch = useDispatch();
  const { formatDateByCountry, getDatePlaceholder, getDateFormat } = DateConversion();
  const { session } = useSelector((state) => state.session);

  // Check if current user is Sales Presales Person (L0, L1, L3)
  const isSalesPresalesPerson = useMemo(() => {
    const authLevel = session?.auth || localStorage.getItem("auth") || localStorage.getItem("userRole");
    return ["L0", "L1", "L3"].includes(authLevel);
  }, [session]);

  const isTruthyRejectedFlag = React.useCallback((value) => {
    if (typeof value === "string") {
      return value.toLowerCase() === "true";
    }
    return Boolean(value);
  }, []);

  const getRejectedProjectFlag = React.useCallback(
    (...sources) =>
      sources.some((source) => {
        if (!source || typeof source !== "object") return false;
        return (
          isTruthyRejectedFlag(source.isRejectedProject) ||
          isTruthyRejectedFlag(source.isRejectedproject)
        );
      }),
    [isTruthyRejectedFlag]
  );

  useEffect(() => {
    dispatch(setCurrentPageTitle("Dashboard"));
  }, [dispatch]);

  const [isLoading, SetisLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [employeesfinalList, setEmployeesfinalList] = useState([]);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [, setOpenPrimamryDropdownIndex] = useState(null);
  const [assignedPeopleList, setAssignedPeopleList] = useState([]);
  const { employees } = useSelector((state) => state.employees);
  const { profiles } = useSelector((state) => state.companyProfile);
  const [openProbabilityIndex, setOpenProbabilityIndex] = useState(null);
  const [probabilityList, setProbabilityList] = useState([]);
  const { projects } = useSelector((state) => state.projects);
  const [, setSelectedIndex] = useState(null);
  const [selectedPrimaryResourceList, setSelectedPrimaryResourceList] =
    useState({});
  const { groups: employeeGroups } = useSelector((state) => state.employeeGroup);
  const { group: allGroups } = useSelector((state) => state.group);
  const [filteredGroupsManager, setFilteredGroupsManager] = useState([]);
  const [openInputReceived, setOpenInputReceived] = useState(null);
  const [sortedProjects, setSortedProjects] = useState([]);
  const [selected, setSelected] = useState(false);
  const [openRow, setOpenRow] = useState(0); // null = none open
  const subscriptionPackage = profiles?.[0]?.subscriptionpackage || "";
  const isCrmPackage = subscriptionPackage?.toUpperCase() === "CRM";

  const [updatedRequestedProjects, setUpdatedProjects] = useState([]);
  const userAuthLevel =
    session?.auth ||
    localStorage.getItem("auth") ||
    localStorage.getItem("userRole");
  const isL3User = String(userAuthLevel || "").toUpperCase() === "L3";
  const loggedInEmail = localStorage.getItem("email");

  // Match by quotationId when available so same Group/Client/ProjectName but different quotationId stay separate
  useEffect(() => {
    const mergedProjects = requestedprojects.map((reqProject) => {
      const match = groupedProjects.find((grpProject) => {
        if (reqProject.quotationId && grpProject.quotationId) return grpProject.quotationId === reqProject.quotationId;
        const reqKey = createProjectKey({ ...reqProject, quotationId: null });
        const grpKey = createProjectKey({ ...grpProject, quotationId: null });
        return reqKey === grpKey;
      });
      return {
        ...reqProject,
        DateDue: match ? match.DateDue : reqProject.DateDue,
      };
    });
    setUpdatedProjects(mergedProjects);
  }, [groupedProjects, requestedprojects]);

  const responseoutstandingref = useRef(null);
  useEffect(() => {
    if ((openRow)) {
      const scrollToPosition = responseoutstandingref.current.scrollWidth;
      responseoutstandingref.current.scrollTo({
        left: scrollToPosition,
        behavior: 'smooth'
      });
    }
  }, [openRow]);

  const scrollToSelectOption = React.useCallback(() => {
    if (responseoutstandingref.current) {
      const el = responseoutstandingref.current;
      el.scrollTo({
        left: el.scrollWidth - el.clientWidth,
        behavior: 'smooth'
      });
    }
  }, []);

  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !event.target.closest('.dropdown-container') // Add this line
      ) {
        setOpenDropdownIndex(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    dispatch(fetchAllProjects());
    dispatch(fetchLeads());
    dispatch(fetchAllProjects());
    dispatch(fetchEmployees());
    dispatch(fetchEmployeeGroups());
    dispatch(fetchGroups());
  }, [dispatch]);

  const l3AllowedGroupIds = useMemo(() => {
    if (!isL3User) return null;
    const loggedEmployee = (employees || []).find(
      (emp) => emp?.EmpEmail === loggedInEmail
    );
    const empGroups = Array.isArray(loggedEmployee?.EmpGroups)
      ? loggedEmployee.EmpGroups
      : [];
    return new Set(empGroups.map((id) => String(id)));
  }, [employees, isL3User, loggedInEmail]);

  useEffect(() => {
    const email = localStorage.getItem("email"); // Make sure this is set in localStorage

    if (employeeGroups && employeeGroups.length > 0 && email) {
      const matchedGroups = employeeGroups.filter(
        (group) => group.createdBy?.EmpEmail === email
      );
      setFilteredGroupsManager(matchedGroups);
    }
  }, [employeeGroups]);

  useEffect(() => {
    setEmployeesfinalList(filteredGroupsManager);
  }, [filteredGroupsManager]);

  const groupNameById = useMemo(() => {
    const map = new Map();
    (allGroups || []).forEach((group) => {
      const id = group?._id;
      const name =
        group?.newGroupName ||
        group?.groupname ||
        group?.groupName ||
        group?.name ||
        "";
      if (id && name) {
        map.set(String(id), name);
      }
    });
    return map;
  }, [allGroups]);

  const getDisplayGroupName = useCallback(
    (projectRow) => {
      if (!projectRow) return "";
      const groupId =
        projectRow?.lead?.groupid?._id ||
        projectRow?.lead?.groupid ||
        projectRow?.groupid?._id ||
        projectRow?.groupid;
      if (groupId && groupNameById.has(String(groupId))) {
        return groupNameById.get(String(groupId));
      }
      return "";
    },
    [groupNameById]
  );

  const filteredProjectsByGroupAccess = useMemo(() => {
    if (!Array.isArray(updatedRequestedProjects)) return [];
    if (!isL3User) return updatedRequestedProjects;
    if (!l3AllowedGroupIds || l3AllowedGroupIds.size === 0) return [];

    return updatedRequestedProjects.filter((projectRow) => {
      const groupId =
        projectRow?.lead?.groupid?._id ||
        projectRow?.lead?.groupid ||
        projectRow?.groupid?._id ||
        projectRow?.groupid;
      return groupId ? l3AllowedGroupIds.has(String(groupId)) : false;
    });
  }, [updatedRequestedProjects, isL3User, l3AllowedGroupIds]);

  const dropdownRefOpenInput = useRef([]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openInputReceived !== null &&
        dropdownRefOpenInput.current[openInputReceived] &&
        !dropdownRefOpenInput.current[openInputReceived].contains(event.target)
      ) {
        setOpenInputReceived(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openInputReceived]);

  const primarydropdownRefs = useRef({});
  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedInsideAny = Object.values(primarydropdownRefs.current).some(
        (ref) => ref && ref.contains(event.target)
      );

      if (!clickedInsideAny) {
        setOpenPrimamryDropdownIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRefsProbability = useRef([]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openProbabilityIndex !== null &&
        dropdownRefsProbability.current[openProbabilityIndex] &&
        !dropdownRefsProbability.current[openProbabilityIndex].contains(
          event.target
        )
      ) {
        setOpenProbabilityIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openProbabilityIndex]);

  const [fileNames, setFileNames] = useState({});
  const showUpgradePopupForErp = () => {
    enqueueSnackbar("Upgrade your package to ERP", { variant: "success" });
  };

  const handleAction = async (selectedValue, index, row) => {
    if (isViewOnly) return;
    setProbabilityList((prev) => {
      const updated = Array.isArray(prev) ? [...prev] : [];
      updated[index] = selectedValue;
      return updated;
    });

    for (const peopleArray of Object.values(assignedPeopleList)) {
      for (const person of peopleArray) {
        if (!person.name) {
          enqueueSnackbar("Please Select Employee", { variant: "error" });
          return;
        }
      }
    }

    if (!assignedPeopleList[index] || assignedPeopleList[index].length === 0) {
      enqueueSnackbar("Please Select employee", {
        variant: "error",
      });
      return;
    }

    console.log("fsfsdf row", row)

    const selectedRow = row;
    const peopleAtIndex = assignedPeopleList[index] || [];
    const TypeServiceMap = peopleAtIndex.reduce((map, person) => {
      const match = employees.find((emp) => {
        const fullName =
          `${emp.EmpFirstName?.trim()} ${emp.EmpLastName?.trim()}`.toLowerCase();
        const personName = person.name?.trim().toLowerCase();
        return emp.EmpEmail === person.email || fullName === personName;
      });

      if (match && match.servicetype) {
        map[person.email] = match.servicetype;
      }

      return map;
    }, {});

    const selectedGroupId =
      selectedRow?.lead?.groupid?._id ||
      selectedRow?.lead?.groupid ||
      selectedRow?.groupid?._id ||
      selectedRow?.groupid ||
      null;

    const projects = [
      {
        AssignedGroup: selectedRow.AssignedGroup,
        groupid: selectedGroupId,
        PrimaryResources: selectedPrimaryResourceList[index], // Check if any primary resource is assigned
        AssignedManagerEmail: peopleAtIndex.map((person) => person.email), // array of email
        TypeServiceMap: TypeServiceMap,
        ClientContactName: selectedRow.ClientContactName,
        ClientEmail: selectedRow.ClientEmail,
        ClientName: selectedRow.ClientName,
        ClientPhone: selectedRow.ClientPhone,
        ProjectDueDate: selectedRow.DateDue
          ? new Date(selectedRow.DateDue).toISOString()
          : null,
        DateRequested: selectedRow.LeadDate,
        FollowupDate: selectedRow.FollowupDate,
        LeadDate: selectedRow.LeadDate,
        LeadOwner: selectedRow.LeadOwner,
        LeadOwnerEmail: selectedRow.LeadOwnerEmail,
        LeadType: selectedRow.LeadType,
        ProjectName: selectedRow.ProjectName,
        quotationId: selectedRow.quotationId,
        QuotedValue: selectedRow.QuotedValue,
        SalesPersonStatus: selectedRow.SalesPersonStatus,
        Source: selectedRow.Source,
        Status: selectedRow.Status,
        SalesPersonEmail: selectedRow.LeadOwnerEmail,
        SalesPersonName: selectedRow.LeadOwner,
      },
    ];

    console.log("fsfsdf", projects)

    const formData = new FormData();
    formData.append("projects", JSON.stringify(projects));
    const files = fileNames[selectedRow.quotationId || selectedRow.ProjectName] || [];
    const categories = files.map((file) => file.selectedCategory);
    files.forEach((file) => {
      formData.append("files", file); // Just the File object
    });
    categories.forEach((category) => {
      formData.append("selectedCategory", category);
    });

    SetisLoading(true);
    try {
      await dispatch(createProjectRequest(formData)).unwrap();
      await handleleadread(selectedRow._id)
      enqueueSnackbar("Project Forwarded Successfully", {
        variant: "success",
      });
      SetisLoading(false);
    } catch (error) {
      console.error("Failed to create task:", error);
      const errorMessage =
        error?.error ||
        error?.message ||
        "Something went wrong. Please try again.";
      enqueueSnackbar(errorMessage, {
        variant: "error",
      });
    } finally {
      SetisLoading(false);
    }
    setAssignedPeopleList([]);
    dispatch(fetchAllProjects());
    setOpenProbabilityIndex(openProbabilityIndex === index ? null : index);
  };

  const handleleadread = async (id) => {
    try {
      await dispatch(markLeadAsReadById(id));
    } catch (error) {
      const errorMessage =
        error?.error ||
        error?.message ||
        "Something went wrong. Please try again.";
      enqueueSnackbar(errorMessage, {
        variant: "error",
      });
    } finally {
      handlerefresh()
      SetisLoading(false);
    }
  };

  useEffect(() => {
    setSortedProjects(filteredProjectsByGroupAccess);
  }, [filteredProjectsByGroupAccess]);

  const itemsPerPage = 10; // or any number of rows you want per page
  const [currentPage, setCurrentPage] = useState(1);

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchInputChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    setCurrentPage(1);
    filterLeadReports(query)
  };

  const totalItems = sortedProjects?.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;
  const paginatedProjects = sortedProjects?.slice(startIdx, endIdx);

  const filterLeadReports = (query) => {
    const lowerCaseQuery = query.toLowerCase().trim();

    const filtered = filteredProjectsByGroupAccess.filter((LeadReport) => {
      const displayGroupName = getDisplayGroupName(LeadReport).toLowerCase();
      if (displayGroupName.includes(lowerCaseQuery)) return true;

      return Object.entries(LeadReport).some(([key, value]) => {
        // Skip these keys
        if (
          key === "Assignedperson" ||
          key === "TypeService" ||
          key === "SalesPersonName" ||
          key === "SalesPersonEmail" ||
          key === "ResourceType" ||
          key === "QuotedValue" ||
          key === "ProjectManagerStatus" ||
          key === "ProjectManagerAction" ||
          key === "createdAt" ||
          key === "updatedAt" ||
          key === "PrimaryResources"
        )
          return false;

        if (value === null || value === undefined) return false;
        if (key === "DateRequested" || key === "ProjectDueDate" || key === "DateDue" || key === "LeadDate") {
          const formattedDate = formatDateByCountry(value);  // ← change here
          return formattedDate.toLowerCase().includes(lowerCaseQuery);
        }
        // Handle all other fields
        const formattedValue = value.toString().trim().toLowerCase();
        return formattedValue.includes(lowerCaseQuery);
      });
    });

    setSortedProjects(filtered);
  };

  const sortAlphabetically = (targetToSort, order) => {
    const key = `${targetToSort}-${order}`;
    let sorted = [...sortedProjects]; // Always sort from the filtered dataset

    const compareStrings = (a, b) => {
      const valA = (a || "").toString().toLowerCase();
      const valB = (b || "").toString().toLowerCase();
      return valA.localeCompare(valB);
    };
    // Helper function for date comparison
    const compareDates = (a, b) => {
      const dateA = a ? new Date(a) : null;
      const dateB = b ? new Date(b) : null;

      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;

      return dateA - dateB;
    };

    switch (key) {
      case "AssignedGroup-az":
        sorted.sort((a, b) => compareStrings(getDisplayGroupName(a), getDisplayGroupName(b)));
        break;
      case "AssignedGroup-za":
        sorted.sort((a, b) => compareStrings(getDisplayGroupName(b), getDisplayGroupName(a)));
        break;
      case "ClientName-az":
        sorted.sort((a, b) => compareStrings(a.ClientName, b.ClientName));
        break;
      case "ClientName-za":
        sorted.sort((a, b) => compareStrings(b.ClientName, a.ClientName));
        break;
      case "ProjectName-az":
        sorted.sort((a, b) => compareStrings(a.ProjectName, b.ProjectName));
        break;
      case "ProjectName-za":
        sorted.sort((a, b) => compareStrings(b.ProjectName, a.ProjectName));
        break;
      case "DateRequested-az":
        sorted.sort((a, b) => compareDates(a.LeadDate, b.LeadDate));
        break;
      case "DateRequested-za":
        sorted.sort((a, b) => compareDates(b.LeadDate, a.LeadDate));
        break;
      case "ProjectDueDate-az":
        sorted.sort((a, b) => compareDates(a.DateDue, b.DateDue));
        break;
      case "ProjectDueDate-za":
        sorted.sort((a, b) => compareDates(b.DateDue, a.DateDue));
        break;
      default:
        // Default to original filtered order
        sorted = [...sortedProjects];
        break;
    }
    setSortedProjects(sorted);
    setCurrentPage(1); // Reset to first page after sorting
  };

  const HandleReassign = async (matchedGroup, manager, index) => {
    if (isViewOnly) return;
    const managerEmployee = employees?.find((emp) => {
      const fullName = `${emp.EmpFirstName} ${emp.EmpLastName}`;
      return fullName === manager;
    });

    const matchedProject = projects.find(
      (project) =>
        project.ProjectName === matchedGroup.ProjectName &&
        project.AssignedManagerEmail.includes(managerEmployee.EmpEmail)
    );
    const quotationId = matchedProject?.quotationId;
    const project = [
      {
        AssignedManagerEmail: matchedProject.AssignedManagerEmail,
        ProjectName: matchedProject.ProjectName,
        quotationId: matchedProject.quotationId,
      },
    ];

    const formData = new FormData();
    formData.append("projects", JSON.stringify(project));
    SetisLoading(true);
    try {
      await dispatch(createProjectRequest(formData)).unwrap();
      if (quotationId) dispatch(setLeadReadTrue(quotationId));
      enqueueSnackbar("Project Re-assigned Successfully", {
        variant: "success",
      });
      SetisLoading(false);
    } catch (error) {
      console.error("Failed to create task:", error);
      SetisLoading(false);
    } finally {
      SetisLoading(false);
      handlerefresh()
    }
    dispatch(fetchAllProjects());
  };

  const HandleManagerCancel = async (matchedGroup, manager, index) => {
    if (isViewOnly) return;
    const managerAction = matchedGroup.ProjectManagerAction.find(
      (action) => action.Manager === manager
    );

    const projectId = managerAction.ProjectId;

    SetisLoading(true);
    try {
      await dispatch(cancelManagerFromProjects(projectId)).unwrap();
      enqueueSnackbar("Manager Removed Successfully", {
        variant: "success",
      });
      SetisLoading(false);
    } catch (error) {
      console.error("Failed to create task:", error);
      SetisLoading(false);
    } finally {
      SetisLoading(false);
    }
    dispatch(fetchAllProjects());
  };

  const ReadOnlyInput = React.forwardRef(
    ({ value, onClick, className }, ref) => (
      <input
        readOnly
        className={`w-full h-full text-center outline-none border cursor-pointer border-gray-300 p-2 rounded-md bg-white ${className}`}
        onClick={onClick}
        value={value}
        ref={ref}
        placeholder="mm-dd-yyyy"
      />
    )
  );

  // Editable input for Sales Presales Person (with border to indicate it's editable)
  const EditableInput = React.forwardRef(
    ({ value, onClick, onChange, className }, ref) => (
      <input
        readOnly
        className={`w-full h-full text-center outline-none border border-gray-400 cursor-pointer p-2 rounded-md bg-white ${className}`}
        onClick={onClick}
        value={value}
        ref={ref}
        placeholder="mm-dd-yyyy"
        onChange={onChange}
      />
    )
  );

  const [, setOpenMenuIdx] = useState(null); // null = no menu open
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpenMenuIdx(null);
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [setOpenMenuIdx]);

  const handleCheckboxChange = async (managerName, quotationId, isCurrentlyPrimary) => {
    if (isViewOnly) return;
    const matchingEmployees = employees.filter(
      (employee) => employee.EmpEmail === managerName.ManagerEmail
    );

    SetisLoading(true);
    try {
      if (!isCurrentlyPrimary) {
        await dispatch(
          updatePrimaryResources({ quotationId, id: matchingEmployees[0]?._id })
        );
        enqueueSnackbar("Primary Manager assigned Successfully", {
          variant: "success",
        });
      } else {
        await dispatch(removePrimaryResources(quotationId));
        enqueueSnackbar("Primary Manager Removed Successfully", {
          variant: "success",
        });
      }
    } catch (error) {
      console.error("Failed to update primary manager:", error);
      enqueueSnackbar("Failed to update primary manager", {
        variant: "error",
      });
    } finally {
      SetisLoading(false);
      dispatch(fetchAllProjects());
      setOpenRow(0);
    }
  };
  // REFACTORED: Now uses projectId from matchedGroup instead of projectName
  // UNDO: Change back to projectName parameter if reverting
  const handleDateChange = async (selectedDate, row, index) => {
    if (isViewOnly) return;
    const updatedProjects =
      updatedRequestedProjects.map(
        (project, i) => {
          if (i === index) {
            return {
              ...project,
              DateDue: selectedDate,
            };
          }
          return project;
        }
      );
    Setrequestedprojects(updatedProjects);
    SetisLoading(true);
    try {
      // Find the matched group using composite key
      const matchedGroup = (groupedProjects || []).find((group) => {
        const rowKey = createProjectKey({
          ProjectName: row.ProjectName,
          ClientName: row.ClientName,
          AssignedGroup: row.AssignedGroup
        });
        const groupKey = createProjectKey({
          ProjectName: group.ProjectName,
          ClientName: row.ClientName,
          AssignedGroup: group.AssignedGroup || row.AssignedGroup
        });
        return rowKey === groupKey;
      });

      // Get projectId from the first project in the group's ProjectManagerAction
      // Since we're updating the due date for the group, we need to update all projects
      // For now, we'll use the first project's ID - backend should handle updating all related projects
      const projectId = matchedGroup?.ProjectManagerAction?.[0]?.ProjectId;
      
      if (!projectId) {
        enqueueSnackbar("Project not found. Please refresh and try again.", {
          variant: "error",
        });
        SetisLoading(false);
        return;
      }

      await dispatch(updateProjectSLAByName({ projectId: projectId, projectDueDate: selectedDate }));
      enqueueSnackbar("Project DueDate Updated Successfully", {
        variant: "success",
      });
    } catch (error) {
      console.error("Failed to create task:", error);
      enqueueSnackbar("Failed to update due date. Please try again.", {
        variant: "error",
      });
    } finally {
      SetisLoading(false);
      dispatch(fetchAllProjects());
    }
  };

  useEffect(() => {
    if (groupedProjects && groupedProjects.length > 0 && updatedRequestedProjects.length > 0) {
      const updatedProjects = updatedRequestedProjects.map(project => {
        const matchedGroup = groupedProjects.find(
          group => (project.quotationId && group.quotationId ? group.quotationId === project.quotationId : group.ProjectName === project.ProjectName)
        );

        if (matchedGroup && matchedGroup.DateDue) {
          return {
            ...project,
            DateDue: new Date(matchedGroup.DateDue)
          };
        }
        return project;
      });
      if (JSON.stringify(updatedProjects) !== JSON.stringify(updatedRequestedProjects)) {
        Setrequestedprojects(updatedProjects);
      }
    }
  }, [groupedProjects, updatedRequestedProjects, Setrequestedprojects]);


  const handleActionafterSalesReject = async (managerAction, index) => {
    if (isViewOnly) return;
    const projectId = managerAction?.ProjectId;
    if (!projectId) {
      console.error("ProjectId not found in managerAction");
      enqueueSnackbar("Project ID not found", { variant: "error" });
      return;
    }
    const selectedProject = projects.find(
      (project) => project._id === projectId
    );
    if (!selectedProject) {
      console.error("Project not found with ID:", projectId);
      enqueueSnackbar("Project not found", { variant: "error" });
      return;
    }
    const project = [
      {
        AssignedManagerEmail: selectedProject.AssignedManagerEmail,
        ProjectName: selectedProject.ProjectName,
        quotationId: selectedProject.quotationId,
      },
    ];
    const formData = new FormData();
    formData.append("projects", JSON.stringify(project));
    SetisLoading(true);
    try {
      await dispatch(createProjectRequest(formData)).unwrap();
      enqueueSnackbar("Project Forwarded Successfully", {
        variant: "success",
      });
      SetisLoading(false);
    } catch (error) {
      console.error("Failed to create task:", error);
      const errorMessage =
        error?.error ||
        error?.message ||
        "Something went wrong. Please try again.";
      enqueueSnackbar(errorMessage, {
        variant: "error",
      });
    } finally {
      SetisLoading(false);
      handlerefresh()
    }
    setAssignedPeopleList([]);
    dispatch(fetchAllProjects());
    setOpenProbabilityIndex(openProbabilityIndex === index ? null : index);
  };

  const HandleManagerReminder = async (matchedGroup, manager, index) => {
    if (isViewOnly) return;
    const managerAction = matchedGroup.ProjectManagerAction.find(
      (action) => action.Manager === manager
    );
    const projectId = managerAction.ProjectId;
    SetisLoading(true);
    try {
      await dispatch(remindManager(projectId));
      enqueueSnackbar("Reminder Send Successfully", {
        variant: "success",
      });
      SetisLoading(false);
    } catch (error) {
      console.error("Failed to create task:", error);
      SetisLoading(false);
    } finally {
      SetisLoading(false);
    }
    dispatch(fetchAllProjects());
  };

  return (
    <>
      {isLoading ? <AdminLoader isLoading={isLoading} /> : <></>}
      <div>
        <div className="w-full pt-2">
          <div className="w-full rounded-lg h-full justify-center">
            <div className="w-full">
              <div>
                <>
                  <div className="flex justify-between items-center p-2 bg-white rounded-t">
                    <div>
                      <h2 className=" font-semibold ">
                        Project Requests
                      </h2>
                    </div>

                    <div className="flex gap-2 p-1 align-middle items-center bg-[#e0e7ff] rounded-full">
                      <MdSearch className=" w-5 h-5 text-gray-500" />
                      <input
                        type="text"
                        value={searchQuery}
                        onChange={handleSearchInputChange}
                        placeholder="Search"
                        className="bg-[#e0e7ff] outline-none w-[80%]"
                      />
                    </div>
                  </div>
                  <div ref={responseoutstandingref} className="relative bg-white rounded-md w-full mb-4 min-h-[20rem] max-h-[90vh] overflow-auto pb-5">
                    <div className="sticky top-0 z-[100]">
                      <div className="head text-center text-xs flex font-semibold  ">
                        <div className="w-14 flex-shrink-0 border p-2 flex justify-center align-middle items-center bg-[#e8e8e8] ">Sr. No</div>
                        <div className="w-36 flex-shrink-0 flex justify-between  items-center align-middle border p-2 truncate line-clamp-2 bg-[#e8e8e8]">
                          Group
                          <div className="flex flex-col">
                            <div
                              className="cursor-pointer "
                              onClick={() =>
                                sortAlphabetically("AssignedGroup", "az")
                              }
                            >
                              <ArrowDropUp
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>

                            <div
                              className="cursor-pointer -mt-2"
                              onClick={() =>
                                sortAlphabetically("AssignedGroup", "za")
                              }
                            >
                              <ArrowDropDown
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="w-36 flex-shrink-0 flex justify-between align-middle items-center border p-2 text-wrap truncate line-clamp-2 bg-[#e8e8e8]">
                          Client Name
                          <div className="flex flex-col">
                            <div
                              className="cursor-pointer "
                              onClick={() =>
                                sortAlphabetically("ClientName", "az")
                              }
                            >
                              <ArrowDropUp
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>

                            <div
                              className="cursor-pointer -mt-2"
                              onClick={() =>
                                sortAlphabetically("ClientName", "za")
                              }
                            >
                              <ArrowDropDown
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="w-36 flex-shrink-0 flex justify-between align-middle items-center border p-2 truncate text-wrap line-clamp-2 bg-[#e8e8e8]">
                          Project Name
                          <div className="flex flex-col">
                            <div
                              className="cursor-pointer "
                              onClick={() =>
                                sortAlphabetically("ProjectName", "az")
                              }
                            >
                              <ArrowDropUp
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>

                            <div
                              className="cursor-pointer -mt-2"
                              onClick={() =>
                                sortAlphabetically("ProjectName", "za")
                              }
                            >
                              <ArrowDropDown
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="w-36 flex-shrink-0  relative flex justify-center items-center align-middle border p-2 truncate break-words text-wrap line-clamp-2 bg-[#e8e8e8]">
                          Date Requested
                          <div className="flex flex-col absolute right-1">
                            <div
                              className="cursor-pointer "
                              onClick={() =>
                                sortAlphabetically("LeadDate", "az")
                              }
                            >
                              <ArrowDropUp
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>

                            <div
                              className="cursor-pointer -mt-2"
                              onClick={() =>
                                sortAlphabetically("LeadDate", "za")
                              }
                            >
                              <ArrowDropDown
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="w-36 flex-shrink-0 relative flex justify-center align-middle items-center border p-2 truncate bg-[#e8e8e8]">
                          Due Date
                          <div className=" flex flex-col absolute right-1">
                            <div
                              className="cursor-pointer "
                              onClick={() =>
                                sortAlphabetically("DateDue", "az")
                              }
                            >
                              <ArrowDropUp
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>

                            <div
                              className="cursor-pointer -mt-2"
                              onClick={() =>
                                sortAlphabetically("DateDue", "za")
                              }
                            >
                              <ArrowDropDown
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="w-28 flex-shrink-0 border p-2 flex justify-center align-middle items-center truncate bg-[#e8e8e8]">
                          Attachment
                        </div>
                        <div className="w-36 flex-shrink-0 border p-2  line-clamp-2 bg-[#e8e8e8]">
                          Assign Task To Managers
                        </div>
                        <div className="w-36 flex-shrink-0 border flex justify-start text-start p-2  line-clamp-2 bg-[#e8e8e8]">
                          Manager's Services
                        </div>
                        <div className="w-36 flex-shrink-0 border p-2 bg-[#e8e8e8]">Action</div>
                      </div>
                    </div>

                    <div className="maindiv flex w-full h-full">
                      <div className="firstdiv w-full h-full">
                        <div className="">
                          {paginatedProjects.map((row, index) => {
                            const matchedGroup = (groupedProjects || []).find((group) => {
                              if (row.quotationId && group.quotationId) return group.quotationId === row.quotationId;
                              const rowKey = createProjectKey({ ...row, quotationId: null });
                              const groupKey = createProjectKey({ ...group, quotationId: null });
                              return rowKey === groupKey;
                            });
                            return (
                              <div
                                key={row.quotationId || row.ProjectName || index}
                                className="flex  text-center table-fixed w-full "
                              >
                                <div
                                  key={index}
                                  className={`flex ${(row.isRead === false) ? "font-bold" : " "} text-sm text-center w-full bg-white text-fixed group hover:bg-gray-100 cursor-pointer`}
                                >
                                  <div className="w-14 flex-shrink-0 border-b p-2.5 flex justify-start align-middle items-center truncate text-xs">
                                    {startIdx + index + 1}
                                  </div>
                                  <div
                                    onClick={() => {
                                      setSelectedIndex(index);
                                      setSelected(!selected)
                                      setOpenRow(
                                        openRow === index ? null : index
                                      ); // toggle this row
                                    }}
                                    className="w-36 flex-shrink-0 text-xs p-2 border-b text-start flex justify-start align-middle items-center"
                                  >
                                    {getDisplayGroupName(row)}
                                  </div>
                                  <div
                                    onClick={() => {
                                      setSelectedIndex(index);
                                      setSelected(!selected)
                                      setOpenRow(
                                        openRow === index ? null : index
                                      ); // toggle this row
                                    }}
                                    className="w-36 flex-shrink-0 text-xs p-2 border-b text-start flex justify-start align-middle items-center"
                                  >
                                    {row.ClientName}
                                  </div>
                                  <div
                                    onClick={() => {
                                      setOpenDropdownIndex(
                                        openDropdownIndex === null
                                      );
                                      setSelectedIndex(index);
                                      setSelected(!selected)
                                      setOpenRow(
                                        openRow === index ? null : index
                                      );
                                    }}
                                    className="w-36 flex-shrink-0 p-2 border-b text-start flex justify-start align-middle items-center"
                                  >
                                    <div className="overflow-hidden text-ellipsis line-clamp-2 break-all break-words leading-snug text-xs text-start">
                                      {row.ProjectName}
                                    </div>
                                  </div>
                                  <div
                                    onClick={() => {
                                      setOpenDropdownIndex(
                                        openDropdownIndex === null
                                      );
                                      setSelectedIndex(index);
                                      setSelected(!selected)
                                      setOpenRow(
                                        openRow === index ? null : index
                                      );
                                    }}
                                    className="w-36 flex-shrink-0 border-b p-2 flex justify-center align-middle items-center text-xs"
                                  >
                                    {row.LeadDate && !isNaN(new Date(row.LeadDate))
                                      ? formatDateByCountry(row.LeadDate)
                                      : " "}

                                  </div>
                                  <div
                                    onClick={() => {
                                      setOpenDropdownIndex(
                                        openDropdownIndex === null
                                      );
                                      setSelectedIndex(index);
                                      setSelected(!selected)
                                      setOpenRow(
                                        openRow === index ? null : index
                                      );
                                    }}
                                    className="w-36 flex-shrink-0 border-b p-2 flex justify-center align-middle items-center text-center text-xs cursor-pointer"
                                  >
                                    <div>
                                      <DatePicker
                                        className="group-hover:bg-gray-100"
                                        selected={
                                          row.DateDue
                                            ? new Date(row.DateDue)
                                            : row.LeadDate
                                              ? new Date(
                                                new Date(
                                                  row.LeadDate
                                                ).getTime() +
                                                7 * 24 * 60 * 60 * 1000
                                              )
                                              : null
                                        }
                                        onChange={(date) => {
                                          const updatedProjects =
                                            updatedRequestedProjects.map(
                                              (project, i) => {
                                                if (i === index) {
                                                  return {
                                                    ...project,
                                                    DateDue: date,
                                                  };
                                                }
                                                return project;
                                              }
                                            );
                                          Setrequestedprojects(updatedProjects);
                                          if (matchedGroup) {
                                            handleDateChange(date, row, index); // REFACTORED: Pass row object instead of just ProjectName
                                          }
                                        }}
                                        dateFormat={getDateFormat()}
                                        placeholder={getDatePlaceholder()}
                                        minDate={row.LeadDate}
                                        customInput={
                                          isSalesPresalesPerson ? (
                                            <EditableInput className="group-hover:bg-gray-100" />
                                          ) : (
                                            <ReadOnlyInput className="group-hover:bg-gray-100" />
                                          )
                                        }
                                        popperClassName="z-[100]"
                                      />
                                    </div>
                                  </div>

                                  <div
                                    onClick={() => {
                                      setOpenDropdownIndex(
                                        openDropdownIndex === null
                                      );
                                      setSelectedIndex(index);
                                      setSelected(!selected)
                                      setOpenRow(
                                        openRow === index ? null : index
                                      );
                                    }}
                                    className="w-28 flex-shrink-0 border-b p-2 flex justify-center align-middle items-center  overflow-hidden"
                                  >
                                    <FileUploadsProjectRequest
                                      setOpenDropdownIndex={
                                        setOpenDropdownIndex
                                      }
                                      openDropdownIndex={openDropdownIndex}
                                      row={row}
                                      setFileNames={setFileNames}
                                      fileNames={fileNames}
                                      isViewOnly={isViewOnly}
                                    />
                                  </div>

                                  <div className="  border-b flex flex-col relative text-xs group-hover:bg-gray-100">
                                    {matchedGroup && (
                                      <div className="flex w-full">
                                        <div
                                          className="w-full cursor-pointer border-r pt-2"
                                          onClick={() => {
                                            setOpenDropdownIndex(
                                              openDropdownIndex === null
                                            );
                                            setSelectedIndex(index);

                                            setOpenRow(
                                              openRow === index ? null : index
                                            );
                                          }}
                                        >
                                          {matchedGroup.AssignedManager &&
                                            matchedGroup.AssignedManager.length >
                                            0 ? (
                                            <>
                                              {openRow !== index ? (
                                                <div className="w-full flex">
                                                  <div className="flex w-36 flex-shrink-0 justify-center align-middle items-center ">
                                                    <p>
                                                      {`Forwarded To ${matchedGroup.AssignedManager.length} ${
                                                        matchedGroup.AssignedManager.length === 1 ? "Manager" : "Managers"
                                                      }`}
                                                    </p>
                                                  </div>

                                                  <div className="w-36 p-2 flex-shrink-0 justify-center">
                                                    {matchedGroup
                                                      .AssignedManager
                                                      .length === 1 ? (
                                                      (
                                                        matchedGroup.ProjectManagerAction ??
                                                        []
                                                      ).map((action, idx) => {
                                                        const services =
                                                          Array.isArray(
                                                            action.TypeService
                                                          )
                                                            ? action.TypeService.join(
                                                              ", "
                                                            )
                                                            : action.TypeService ??
                                                            "";

                                                        return (
                                                          <span
                                                            key={idx}
                                                            className="inline-flex"
                                                          >
                                                            {services}
                                                            {idx <
                                                              matchedGroup
                                                                .ProjectManagerAction
                                                                .length -
                                                              1 && ","}
                                                          </span>
                                                        );
                                                      })
                                                    ) : (
                                                      <>Multiple</>
                                                    )}
                                                  </div>
                                                  <div className="w-36 flex-shrink-0 ">



                                                  </div>
                                                </div>
                                              ) : (
                                                <div className="w-full">
                                                  <div className=" w-[100%]">
                                                    {(() => {

                                                      const projectActions =
                                                        matchedGroup.ProjectManagerAction ||
                                                        [];
                                                      const isGlobalRejected =
                                                        projectActions.some(
                                                          (action) =>
                                                            (
                                                              action.ResourceType ||
                                                              ""
                                                            ).toLowerCase() ===
                                                            "primary" &&
                                                            (
                                                              action.ManagerAction ||
                                                              ""
                                                            ).toLowerCase() ===
                                                            "rejected"
                                                        );

                                                      return projectActions.map(
                                                        (
                                                          action,
                                                          managerIndex
                                                        ) => {
                                                          const isPrimary =
                                                            action.ResourceType === "Primary"
                                                          const isRejected =
                                                            (
                                                              action.ManagerAction ||
                                                              ""
                                                            ).toLowerCase() ===
                                                            "rejected";
                                                          const showExclamation =
                                                            isGlobalRejected ||
                                                            isRejected;

                                                          const hasResponse = action.AssignedPerson &&
                                                            action.AssignedPerson.length > 0 &&
                                                            action.AssignedPerson.every(
                                                              person => person.manageraction === "complete"
                                                            );
                                                          const today =
                                                            new Date();
                                                          const dueDate =
                                                            new Date(
                                                              matchedGroup.DateDue
                                                            );
                                                          // strip time from both
                                                          const isSameDay =
                                                            dueDate.getFullYear() === today.getFullYear() &&
                                                            dueDate.getMonth() === today.getMonth() &&
                                                            dueDate.getDate() === today.getDate();

                                                          const isOverdue = dueDate < today && !isSameDay;
                                                          const salesReject = action?.ProjectManagerActionSummary === "reject-forward"

                                                          return (
                                                            <div className="flex w-full ">
                                                              <div
                                                                title={
                                                                  isPrimary
                                                                    ? "Primary resource"
                                                                    : ""
                                                                }
                                                                key={
                                                                  managerIndex
                                                                }
                                                                className="relative w-36 flex-shrink-0 p-2 flex items-center align-middle justify-between
                                                                  text-xs text-gray-700"
                                                              >
                                                                <button
                                                                  title={isPrimary ? "Remove Primary resource " : "Select Primary Resource"}
                                                                  className="primaryselector focus:outline-none p-1"
                                                                  onClick={() => {
                                                                    handleCheckboxChange(action, row.quotationId, isPrimary);

                                                                  }
                                                                  }
                                                                >
                                                                  <Star
                                                                    size={20}
                                                                    fill={isPrimary ? "#FFD700" : "none"}
                                                                    stroke={isPrimary ? "#FFD700" : "#000000"}
                                                                    className={`transition-colors ${!isPrimary ? 'opacity-30' : 'cursor-pointer hover:stroke-yellow-500'}`}
                                                                  />
                                                                </button>
                                                                {action.Manager}

                                                                {salesReject ? (
                                                                  <div
                                                                    title="Rejected"
                                                                    className=" right-2 text-red-800 cursor-default font-bold text-xl"
                                                                  >
                                                                    !
                                                                  </div>
                                                                ) :
                                                                  showExclamation ? (
                                                                    <div
                                                                      title="Rejected By Manager"
                                                                      className=" right-2 text-red-800 cursor-default font-bold text-xl"
                                                                    >
                                                                      !
                                                                    </div>
                                                                  ) : hasResponse ? (
                                                                    <div
                                                                      className=" right-0 cursor-default"
                                                                      title="Completed"
                                                                    >
                                                                      <CheckIcon className="text-green-600" />
                                                                    </div>
                                                                  ) :
                                                                    (isOverdue) ? (
                                                                      <div
                                                                        title="Overdue"
                                                                        className=" right-2 text-red-800 cursor-default font-bold text-sm"
                                                                      >
                                                                        ⏳
                                                                      </div>
                                                                    ) : (
                                                                      <div
                                                                        title="Pending"
                                                                        className=" right-2 text-orange-400 cursor-default font-bold text-sm"
                                                                      >
                                                                        ⏳
                                                                      </div>
                                                                    )}
                                                              </div>
                                                              <div className="w-36 p-2 flex-shrink-0 flex justify-center align-middle items-center ">
                                                                {
                                                                  action.TypeService
                                                                }
                                                              </div>
                                                              <div className="w-36 flex-shrink-0 AssignedManagerbox flex justify-center align-middle items-center ">
                                                                {(() => {
                                                                  const projectActions = matchedGroup.ProjectManagerAction || [];
                                                                  const hasRejectedAction = action?.ProjectManagerActionSummary === "rejected";
                                                                  const hasRejectForward = action?.ProjectManagerActionSummary === "reject-forward";
                                                                  const isRejectedProjectFlag = getRejectedProjectFlag(
                                                                    row,
                                                                    row?.projectdata,
                                                                    matchedGroup,
                                                                    matchedGroup?.projectdata,
                                                                    action,
                                                                    action?.projectdata,
                                                                    ...(projectActions || []),
                                                                    ...(projectActions || []).map((item) => item?.projectdata)
                                                                  );
                                                                  const hasRejectForwardInGroup = projectActions.some(
                                                                    (item) => item?.ProjectManagerActionSummary === "reject-forward"
                                                                  );
                                                                  const rejectForwardAction = projectActions.find(
                                                                    (item) => item?.ProjectManagerActionSummary === "reject-forward"
                                                                  );
                                                                  const shouldShowReassign =
                                                                    hasRejectedAction || isRejectedProjectFlag;

                                                                  if (
                                                                    process.env.NODE_ENV !== "production" &&
                                                                    row?.quotationId
                                                                  ) {
                                                                    console.log("[ProjectRequest][Reassign Debug]", {
                                                                      quotationId: row?.quotationId,
                                                                      projectName: row?.ProjectName,
                                                                      manager: action?.Manager,
                                                                      rowIsRejectedProject: row?.isRejectedProject,
                                                                      rowIsRejectedproject: row?.isRejectedproject,
                                                                      actionIsRejectedProject: action?.isRejectedProject,
                                                                      actionIsRejectedproject: action?.isRejectedproject,
                                                                      projectManagerAction: action?.ManagerAction ?? row?.ProjectManagerAction,
                                                                      actionSummary: action?.ProjectManagerActionSummary,
                                                                      hasRejectedAction,
                                                                      isRejectedProjectFlag,
                                                                      shouldShowReassign,
                                                                    });
                                                                  }

                                                                  const handleSelectChange = (e) => {
                                                                    const selectedValue = e.target.value;

                                                                    switch (selectedValue) {
                                                                      case 'reassign-rejected':
                                                                        projectActions.forEach((actionItem) => {
                                                                          if ((actionItem.ManagerAction || "").toLowerCase() === "rejected") {
                                                                            HandleReassign(matchedGroup, actionItem.Manager, index);
                                                                          }
                                                                        });
                                                                        if (
                                                                          isRejectedProjectFlag &&
                                                                          !projectActions.some(
                                                                            (actionItem) =>
                                                                              (actionItem.ManagerAction || "").toLowerCase() === "rejected"
                                                                          )
                                                                        ) {
                                                                          handleActionafterSalesReject(rejectForwardAction || action);
                                                                        }
                                                                        break;

                                                                      case 'reassign-reject-forward':
                                                                        handleActionafterSalesReject(rejectForwardAction || action);
                                                                        break;

                                                                      case 'reminder':
                                                                        if (!hasResponse) {
                                                                          HandleManagerReminder(matchedGroup, action.Manager, index);
                                                                        }
                                                                        break;

                                                                      case 'cancel':
                                                                        if (projectActions.length > 0) {
                                                                          HandleManagerCancel(matchedGroup, action.Manager, index);
                                                                        }
                                                                        break;

                                                                      default:
                                                                        break;
                                                                    }
                                                                    e.target.value = '';
                                                                  };

                                                                  const handleSelectClick = (e) => {
                                                                    e.stopPropagation(); // Prevent click from bubbling to parent elements
                                                                  };

                                                                  return (
                                                                    <div className="w-full flex justify-center items-center align-middle py-2">
                                                                      <div className="w-[80%] relative">
                                                                        <select
                                                                          onChange={handleSelectChange}
                                                                          onClick={handleSelectClick}
                                                                          onMouseDown={handleSelectClick}
                                                                          className={`w-full border text-xs border-gray-400 rounded-md p-2 shadow-md appearance-none outline-none bg-white ${isViewOnly ? "opacity-50 cursor-not-allowed" : ""}`}
                                                                          defaultValue=""
                                                                          disabled={isViewOnly}
                                                                        >
                                                                          <option hidden value="" disabled>Forwarded</option>

                                                                          {/* Show Reassign only once (avoid duplicate label when both conditions are true) */}
                                                                          {shouldShowReassign ? (
                                                                            <option value="reassign-rejected">Reassign</option>
                                                                          ) : hasRejectForwardInGroup ? (
                                                                            <option value="reassign-reject-forward">Reassign</option>
                                                                          ) : null}

                                                                          {/* Reminder option */}
                                                                          {((hasResponse || hasRejectedAction || hasRejectForward) || (hasResponse && !hasRejectForward) || (hasResponse && !hasRejectedAction)) ? (
                                                                            <></>
                                                                          ): (
                                                                            <option value="reminder">Reminder</option>
                                                                          )}

                                                                          {/* Cancel option */}
                                                                          <option value="cancel">Cancel</option>
                                                                        </select>

                                                                        {/* Custom dropdown arrow */}
                                                                        <div
                                                                          className="absolute top-1/2 right-2 transform -translate-y-1/2 pointer-events-none"
                                                                          onClick={handleSelectClick} // Also prevent clicks on the arrow icon
                                                                        >
                                                                          <ExpandMoreIcon className="text-gray-600" />
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  );
                                                                })()}
                                                              </div>

                                                            </div>
                                                          );
                                                        }
                                                      );
                                                    })()}
                                                  </div>
                                                </div>
                                              )}
                                            </>
                                          ) : (
                                            <div className="w-full h-[60px] flex items-center justify-center text-sm text-gray-700">
                                              No Assigned Manager
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    )}

                                    <div className=" flex">
                                      <div className=" mt-2 ">
                                        <div className="flex w-full">
                                          <div
                                            className="flex w-36 flex-shrink-0  pt-1 justify-center align-middle items-center">


                                            {isCrmPackage ? (
                                              <div
                                                onClick={showUpgradePopupForErp}
                                                className="w-full border text-xs border-gray-400 rounded-md p-2 shadow-md text-center cursor-pointer bg-white"
                                              >
                                                Select Employee
                                              </div>
                                            ) : isViewOnly ? (
                                              <div
                                                className="w-full border text-xs border-gray-400 rounded-md p-2 shadow-md text-center bg-white opacity-50 cursor-not-allowed"
                                              >
                                                Select Employee
                                              </div>
                                            ) : (
                                              <EmployeeDropdown
                                                index={index}
                                                row={row}
                                                isOpen={openDropdownIndex === index}
                                                onClose={(open) => {
                                                  setOpenDropdownIndex(open ? index : null);
                                                }}
                                                assignedPeopleList={assignedPeopleList}
                                                employeesfinalList={employeesfinalList}
                                                matchedGroup={matchedGroup}
                                                setAssignedPeopleList={setAssignedPeopleList}
                                                selectedPrimaryResourceList={selectedPrimaryResourceList}
                                                setSelectedPrimaryResourceList={setSelectedPrimaryResourceList}
                                                employees={employees}
                                                setOpenRow={setOpenRow}
                                                openRow={openRow}
                                                onScrollToSelectOption={scrollToSelectOption}
                                              />
                                            )}
                                          </div>
                                          <div onClick={() => {
                                            setOpenDropdownIndex(null);
                                          }}
                                            className="flex w-36 flex-shrink-0 pt-1 justify-center align-middle items-center dropdown-container">

                                          </div>
                                        </div>

                                        {openRow === index && (
                                          <div className="w-full flex pb-2 ">
                                            <div className="assignedPeopleList  flex w-full  ">
                                              {assignedPeopleList[index]?.length >
                                                0 && (
                                                  <div className="text-xs text-gray-700 flex flex-col gap-1 w-full">
                                                    {assignedPeopleList[index].map(
                                                      (person, idx) => {
                                                        // Find the matching employee in your employee state
                                                        const matchedEmployee =
                                                          employees.find(
                                                            (emp) =>
                                                              emp.EmpEmail ===
                                                              person.email
                                                          );
                                                        const serviceType =
                                                          matchedEmployee
                                                            ? matchedEmployee.servicetype
                                                            : " ";

                                                        return (
                                                          <div
                                                            className="flex w-full"
                                                            key={idx}
                                                          >
                                                            <div
                                                              className={`relative w-[50%] p-4 flex text-xs  items-center justify-center  text-gray-700`}
                                                            >
                                                              <span>{person.name}</span>
                                                            </div>
                                                            <div
                                                              className={`w-[50%] flex p-2 justify-center  align-middle items-center `}
                                                            >
                                                              {serviceType}{" "}
                                                              {/* This will display the servicetype */}
                                                            </div>

                                                          </div>
                                                        );
                                                      }
                                                    )}
                                                  </div>
                                                )}

                                            </div>
                                          </div>
                                        )}
                                      </div>

                                      <div className="w-36 flex-shrink-0 flex justify-center align-middle items-center">


                                        <div className="w-[80%] assignebutton h-full pt-1 flex flex-col justify-center align-bottom">
                                          {isCrmPackage ? (
                                            <div
                                              onClick={showUpgradePopupForErp}
                                              className="w-full border text-xs bg-white border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden outline-none cursor-pointer flex justify-between items-center"
                                            >
                                              <span>Select Option</span>
                                              <ExpandMoreIcon className="text-gray-600" />
                                            </div>
                                          ) : (
                                            <div className="relative flex p-0 rounded-xl align-middle items-center">
                                              <select
                                                className={`forward appearance-none border w-full text-xs bg-white border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden outline-none ${isViewOnly ? "opacity-50 cursor-not-allowed" : ""}`}
                                                value={probabilityList[index] || ""}
                                                disabled={isViewOnly}
                                                onChange={(e) => {
                                                  const value = e.target.value;

                                                  if (value === "Forward") {
                                                    handleAction("Forward", index, row);
                                                    setOpenDropdownIndex(null);
                                                    const updated = [...probabilityList];
                                                    updated[index] = "";
                                                    setProbabilityList(updated);
                                                    return;
                                                  }
                                                  const updated = [...probabilityList];
                                                  updated[index] = value;
                                                  setProbabilityList(updated);
                                                }}
                                              >
                                                <option hidden value="">Select Option</option>
                                                <option value="Forward">Forward</option>
                                              </select>
                                              <div
                                                className="absolute top-1/2 right-2 transform -translate-y-1/2 pointer-events-none"
                                              >
                                                <ExpandMoreIcon className="text-gray-600" />
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>

                        {paginatedProjects.length === 0 && (
                          <div className="noDataAvailable p-2">
                            No Result Found
                          </div>
                        )}
                      </div>
                    </div>
                  </div>


                  <div
                    className={`pagination flex justify-between  text-xs items-center bg-white rounded-md ${paginatedProjects.length > 0 ? "p-1" : ""
                      } `}
                  >
                    <div>
                      {totalItems > 0 ? (
                        <>
                          Showing {startIdx + 1} to{" "}
                          {Math.min(endIdx, totalItems)} of {totalItems} Entries
                        </>
                      ) : (
                        <>
                          {paginatedProjects.length > 0 && (
                            <>Showing {paginatedProjects.length} Entries</>
                          )}
                        </>
                      )}
                    </div>

                    {totalPages > 1 && (
                      <div className="flex">
                        <button
                          onClick={() => setCurrentPage(1)}
                          className="px-2 py-2 mx-1 border rounded"
                          disabled={currentPage === 1}
                          title="First Page"
                        >
                          <KeyboardDoubleArrowLeftIcon className="w-5 h-5" />
                        </button>
                        <button
                          onClick={() =>
                            setCurrentPage((prev) => Math.max(prev - 1, 1))
                          }
                          className="px-2 py-2 mx-2 border rounded"
                          disabled={currentPage === 1}
                        >
                          <ChevronRightIcon className="w-5 h-5 rotate-180" />
                        </button>

                        {Array.from({ length: 3 }, (_, index) => {
                          const pageNumber = currentPage - 1 + index;
                          if (pageNumber >= 1 && pageNumber <= totalPages) {
                            return (
                              <button
                                key={pageNumber}
                                onClick={() => setCurrentPage(pageNumber)}
                                className={`px-4 py-2 mx-2 border rounded ${currentPage === pageNumber
                                  ? "bg-gray-300"
                                  : ""
                                  }`}
                              >
                                {pageNumber}
                              </button>
                            );
                          }
                          return null;
                        })}

                        <button
                          onClick={() =>
                            setCurrentPage((prev) =>
                              Math.min(prev + 1, totalPages)
                            )
                          }
                          className="px-2 py-2 mx-2 border rounded"
                          disabled={currentPage === totalPages}
                        >
                          <ChevronRightIcon className="w-5 h-5" />
                        </button>

                        <button
                          onClick={() => setCurrentPage(totalPages)}
                          className="px-2 py-2 mx-1 border rounded"
                          disabled={currentPage === totalPages}
                          title="Last Page"
                        >
                          <KeyboardDoubleArrowRightIcon className="w-5 h-5" />
                        </button>
                      </div>
                    )}
                  </div>
                </>
              </div>
            </div >
          </div >
        </div >
      </div >
    </>
  );
};

export default SalesPresalesOperations;
